const formatCPF = value => {
  const valueFormatted = value
    .toString()
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  return valueFormatted;
};

const formatPhone = value => {
  const valueFormatted = value
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/g, '($1) $2')
    .replace(/(\d)(\d{4})$/, '$1-$2');
  return valueFormatted;
};

const setFormatter = (format, value) => {
  switch (format) {
    case 'cpf':
      return formatCPF(value);
    case 'phone':
      return formatPhone(value);
    default:
      return value;
  }
};

export default setFormatter;
